import { useEffect, useState } from "react";
import api, { apiErrorMessage, formatDate, safeLink } from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { toast } from "sonner";

const STATUS = ["nowe", "rozpatrywane", "zaakceptowane", "odrzucone"];
const STATUS_LABEL = { nowe: "Nowe", rozpatrywane: "Rozpatrywane", zaakceptowane: "Zaakceptowane", odrzucone: "Odrzucone" };

export default function ManagerCustomRequests() {
  const [list, setList] = useState([]);
  const [comments, setComments] = useState({});

  const reload = () => api.get("/custom-product-requests").then((r) => setList(r.data));
  useEffect(() => { reload(); }, []);

  const review = async (id, status) => {
    try {
      await api.patch(`/custom-product-requests/${id}`, { status, manager_comment: comments[id] || null });
      toast.success("Zaktualizowano status");
      reload();
    } catch (e) {
      toast.error(apiErrorMessage(e));
    }
  };

  const toggleSuggest = async (req) => {
    try {
      await api.patch(`/custom-product-requests/${req.id}`, {
        status: req.status === "nowe" ? "rozpatrywane" : req.status,
        suggest_add_to_catalog: !req.suggest_add_to_catalog,
      });
      toast.success(req.suggest_add_to_catalog ? "Cofnięto sugestię" : "Oznaczono jako sugerowane do katalogu");
      reload();
    } catch (e) {
      toast.error(apiErrorMessage(e));
    }
  };

  return (
    <div>
      <PageHeader testId="manager-custom" title="Zapytania o produkty spoza katalogu" subtitle={`${list.length} zapytań`} />
      <div className="ol-card overflow-hidden">
        {list.length === 0 ? (
          <div className="p-12 text-center text-sm text-slate-500">Brak zapytań.</div>
        ) : (
          <table className="ol-table">
            <thead>
              <tr><th>Data</th><th>Pracownik</th><th>Produkt</th><th>Ilość</th><th>Komentarz</th><th>Status</th><th></th></tr>
            </thead>
            <tbody>
              {list.map((r) => (
                <tr key={r.id} className="align-top">
                  <td className="text-xs text-slate-600">{formatDate(r.created_at)}</td>
                  <td>{r.requested_by_name}</td>
                  <td>
                    <p className="font-medium">{r.product_name}</p>
                    {r.product_link && <a href={safeLink(r.product_link)} target="_blank" rel="noreferrer" className="ol-link text-xs">link</a>}
                    {r.suggest_add_to_catalog && (
                      <p className="text-xs text-[#CC4B00] font-semibold mt-0.5">✦ Sugerowane do katalogu</p>
                    )}
                  </td>
                  <td>{r.estimated_quantity}</td>
                  <td className="max-w-xs text-sm text-slate-700">{r.comment || "—"}</td>
                  <td><span className="ol-badge bg-slate-100 text-slate-700 border border-slate-200">{STATUS_LABEL[r.status]}</span></td>
                  <td>
                    <div className="flex flex-col gap-1.5 w-52">
                      <label className="flex items-start gap-2 cursor-pointer p-2 rounded border border-slate-200 hover:border-[#FF6B1A] bg-slate-50/60">
                        <input type="checkbox" checked={!!r.suggest_add_to_catalog} onChange={() => toggleSuggest(r)}
                          data-testid={`mgr-suggest-${r.id}`}
                          className="mt-0.5 w-3.5 h-3.5 accent-[#FF6B1A]" />
                        <span className="text-xs text-slate-700 leading-tight">Sugeruj dodać do katalogu na stałe</span>
                      </label>
                      <input
                        placeholder="Komentarz kierownika"
                        value={comments[r.id] || ""}
                        onChange={(e) => setComments({ ...comments, [r.id]: e.target.value })}
                        className="px-2 py-1 rounded border border-slate-300 text-xs focus:border-[#FF6B1A] focus:outline-none"
                      />
                      <div className="flex gap-1 flex-wrap">
                        {STATUS.filter(s => s !== r.status).map((s) => (
                          <button key={s} onClick={() => review(r.id, s)} data-testid={`set-status-${r.id}-${s}`}
                            className="px-2 py-1 rounded border border-slate-300 hover:border-[#FF6B1A] hover:text-[#FF6B1A] text-xs font-semibold">
                            {STATUS_LABEL[s]}
                          </button>
                        ))}
                      </div>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
